export default __webpack_public_path__ + "static/media/DisCreateIP.58462ec7.svg";